module.exports = __webpack_public_path__ + "img/img0.975c10f4.jpg";